export default {
  GET_TechnicianUsers: [],
};
